import React from 'react';
import styled from 'styled-components';
import { Caption, Theme } from '@routific/hive';

interface FormLabelProps {
  title: string;
  htmlFor?: string;
  required?: boolean;
  disabled?: boolean;
}

const LabelContainer = styled.span`
  display: flex;
  gap: ${Theme.Spacing.xsSpacing};
  margin-bottom: ${Theme.Spacing.xsSpacing};
`;

const Label = styled.span<{ disabled?: boolean }>`
  color: ${({ disabled }) => (disabled ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,.85)')};
`;

const FormLabel: React.FC<FormLabelProps> = ({ title, htmlFor, required, disabled }) => {
  return (
    <LabelContainer as={htmlFor ? 'label' : undefined} htmlFor={htmlFor}>
      <Caption>
        <Label disabled={disabled}>{title}</Label>
      </Caption>
      {required && <Caption type="danger">*</Caption>}
    </LabelContainer>
  );
};

export default FormLabel;
